import { AxiosResponse } from 'axios';
import { RestServiceConnection } from '../restServiceConnection';

const ENDPOINT = '/dashboard';

export class DashboardService extends RestServiceConnection {

    getDashboard = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/get',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }

}